// extracted by mini-css-extract-plugin
export default {"loadingComponent":"SingleProduct_loadingComponent__eYG6a","singleProductContainer":"SingleProduct_singleProductContainer__x+KJ1"};